import PropTypes from "prop-types"
import { Grid } from "@mui/material"
import Dropdown from "components/fields/Dropdown"
import { useForms } from "hooks/useForm"
import { useEffect, useRef, useState } from "react"
import { useFormContext } from "react-hook-form"

const DEFAULT_FIRST_VALUES = ["France"]

const CountryResidence = ({
  countriesId = "0Nt08000000bqgi",
  firstValues = DEFAULT_FIRST_VALUES,
  label = "Pays de résidence",
  name = "lead.Country",
  native = false,
  required = true,
  sm = 6
}) => {
  const { control } = useFormContext()
  const { componentFetched, salesforce, setComponentStates, setOpenSnackbar, setSnackMessage } = useForms()
  const [countries, setCountries] = useState([])
  const hasFetchedCountries = useRef(false)
  const firstValuesKey = Array.isArray(firstValues) ? firstValues.join("|") : ""

  useEffect(() => {
    hasFetchedCountries.current = false
  }, [countriesId, firstValuesKey])

  useEffect(() => {
    setComponentStates((prevState) => [
      ...prevState,
      { name: "countryResidence", added: true, fetched: false }
    ])
  }, [setComponentStates])

  useEffect(() => {
    if (salesforce !== null && !hasFetchedCountries.current) {
      hasFetchedCountries.current = true

      const getData = async () => {
        const resolvedFirstValues = firstValuesKey ? firstValuesKey.split("|") : []
        const countriesList = await salesforce.getCountries(countriesId, resolvedFirstValues)
        return { countriesList }
      }

      getData().then((value) => {
        const { countriesList } = value
        setCountries(countriesList)
        componentFetched("countryResidence")
      }).catch((error) => {
        hasFetchedCountries.current = false
        setOpenSnackbar(true)
        console.log("erreur", error)
        setSnackMessage("Une erreur est survenue lors du chargement du formulaire")
      })
    }
  }, [componentFetched, countriesId, firstValuesKey, salesforce, setOpenSnackbar, setSnackMessage])

  return (
    <Grid item sm={sm} xs={12}>
      <Dropdown control={control} label={label} name={name} native={native} options={countries} required={required} />
    </Grid>
  )
}

CountryResidence.propTypes = {
  countriesId: PropTypes.string,
  firstValues: PropTypes.array,
  label: PropTypes.string,
  name: PropTypes.string,
  native: PropTypes.bool,
  required: PropTypes.bool,
  sm: PropTypes.number
}

export default CountryResidence
